import React from "react";
// Local Component
import CreateWallet from "./CreateWallet";
import WalletTable from "./WalletTable";

const Wallet: React.FC = () => {
  // states
  const [refreshFlag, setRefreshFlag] = React.useState(false);

  return (
    <div
      className={`flex flex-row items-start justify-start  gap-3 w-full h-fit px-7`}
    >
      <CreateWallet setRefreshFlag={setRefreshFlag} />
      <WalletTable refreshFlag={refreshFlag} />
    </div>
  );
};

export default Wallet;
